/* eslint-disable quotes */
import { snakelize, camelize } from "../../../helpers/object";

export default ($axios: any): any => ({
    // 메뉴 리스트 카테고리 + 스타일
    async index(data?: any) {
        return camelize(
            await $axios.get(`/menu/list`, { params: snakelize(data) })
        );
    },

    // 카테고리
    async categories(data?: any) {
        return camelize(
            await $axios.get(`/menu/category`, { params: snakelize(data) })
        );
    },

    // 스타일
    async styles(data?: any) {
        return camelize(
            await $axios.get(`/menu/style`, { params: snakelize(data) })
        );
    },

    // 브랜드 리스트
    async brands(data?: any) {
        return camelize(
            await $axios.get(`/menu/brand`, { params: snakelize(data) })
        );
    },

    async status(data?: any) {
        return camelize(
            await $axios.get(`/is_open`, { params: snakelize(data) })
        );
    },
});
